import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { hideTables } from "../../../../services/Admin/TablesApi";

const DeleteTablesDialog = ({ open, onClose, onHidden }) => {
  const [tablesNumber, setTablesNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const reset = () => {
    setTablesNumber(1);
    setError(null);
  };

  const handleClose = () => {
    if (!loading) {
      reset();
      onClose && onClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const n = Number(tablesNumber);
    if (!Number.isFinite(n) || n <= 0 || !Number.isInteger(n)) {
      setError("يرجى إدخال عدد صحيح موجب للطاولات");
      return;
    }

    setLoading(true);
    try {
      const res = await hideTables({ tables_number: n });
      onHidden && onHidden(res?.data ?? res);
      reset();
      onClose && onClose();
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء إخفاء الطاولات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={handleClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>إخفاء طاولات</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            سيتم إخفاء عدد الطاولات المحدد. هل تريد المتابعة؟
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="عدد الطاولات المراد إخفاؤها"
            type="number"
            fullWidth
            inputProps={{ min: 1 }}
            value={tablesNumber}
            onChange={(e) => setTablesNumber(e.target.value)}
            disabled={loading}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            إلغاء
          </Button>
          <Button type="submit" variant="contained" color="error" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "إخفاء"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DeleteTablesDialog;
